import DefaultBannerImage from "../../assets/default_banner.jpg";
import { jsx as _jsx } from "react/jsx-runtime";
export function ProjectBanner(props) {
  var _props$classNameOverr;
  const projectBannerImage = props.bannerHash ? `https://${process.env.REACT_APP_PINATA_GATEWAY}/ipfs/${props.bannerHash}` : DefaultBannerImage;
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx("img", {
      className: (_props$classNameOverr = props.classNameOverride) !== null && _props$classNameOverr !== void 0 ? _props$classNameOverr : "h-[120px] w-full object-cover rounded-t",
      src: `${projectBannerImage}${props.resizeHeight ? "?img-height=" + props.resizeHeight : ""}`,
      alt: "Project Banner"
    })
  });
}